import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Row } from '@cuemath/comps';
import { Dropdown } from '@cuemath/web-comps';
import { DAYS_NAME } from 'constants/student-transfer';
import CueTimeInput from 'comps/inputs/cueTimeInput';

const NameCardWrapper = styled(Row)`
  position: relative;
  gap: 16px;
  margin-top: 2px;
`;

const DropdownWrapper = styled.div`
  width: 160px;
`;

const DateInputWrapper = styled.div`
  width: 144px;

  .cue-time-input > label input {
    height: 44px;
  }
`;

// Slot times must land on a 5-minute boundary. The native step={300} restricts
// the picker's steppers, but a typed value can still be off-grid, so round the
// minutes to the nearest 5 defensively. Value is "HH:MM".
const roundTimeToFiveMinutes = value => {
  if (!value || !value.includes(':')) {
    return value;
  }
  const [hh, mm] = value.split(':');
  const minutes = parseInt(mm, 10);
  if (Number.isNaN(minutes)) {
    return value;
  }
  let rounded = Math.round(minutes / 5) * 5;
  let hours = parseInt(hh, 10) || 0;
  if (rounded === 60) {
    rounded = 0;
    hours = (hours + 1) % 24;
  }
  return `${String(hours).padStart(2, '0')}:${String(rounded).padStart(2, '0')}`;
};

const StudentTransferSlotsList = ({ day, time, id, updateSlotsList, slotsList }) => {
  const [selectDay, setSelectDay] = useState('');
  const [selectTime, setSelectTime] = useState('');

  useEffect(() => {
    if (selectDay || selectTime) {
      updateSlotsList({
        day: selectDay,
        time: selectTime,
        id,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectDay, selectTime]);

  useEffect(() => {
    if (!time) {
      setSelectTime('');
    }
  }, [day, time]);

  const showError =
    selectDay &&
    slotsList?.find(slotData => slotData.id !== id && slotData.day === selectDay);

  return (
    <NameCardWrapper nowrap alignItem="center">
      <DropdownWrapper>
        <Dropdown
          width="160px"
          options={DAYS_NAME}
          value={selectDay}
          onChange={value => setSelectDay(value)}
          type="primary"
          height="max-content"
          placeholder="Choose day"
          restrictSearch
          error={!!showError && 'Same day selected.'}
        />
      </DropdownWrapper>
      <DateInputWrapper>
        <CueTimeInput
          value={selectTime}
          step={300}
          onChange={value => setSelectTime(roundTimeToFiveMinutes(value))}
        />
      </DateInputWrapper>
    </NameCardWrapper>
  );
};

export default StudentTransferSlotsList;
